<form [formGroup]="form" (ngSubmit)="handleSubmit()" class="form-builder-answer-component">
  <div class="card card-fit shadow mt-2">
    <div class="card-header border-bottom" *ngIf="showHeader">
      <h4 class="mb-0">{{ group.label }}</h4>
    </div>
    <div class="card-body pt-2">
      <div
        *ngFor="let item of items; let i = index"
        class="mb-1 question-block"
        [ngClass]="{ 'child-item': item.isChild }"
      >
        <label class="form-control-label"class="question-label label-small question-label-wrapper">
          <span class="question-label-content">
            <span *ngIf="!item.isChild" class="bullet-icon bullet-circle"></span>

            {{ item.label }}

            <span *ngIf="item.required" class="required-indicator">*</span>
          </span>

          <ng-container *ngIf="item.inputType === 'TEXTAREA'">
            <button
              type="button"
              class="btn btn-link-secondary btn-sm p-0 question-label-toggle"
              (click)="toggleCollapse(item.id)"
              [ngClass]="{ 'child-button': item.isChild }"
            >
              <i [class]="isExpanded(item.id) ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
            </button>
          </ng-container>
        </label>

        <div
          *ngIf="item.description"
          class="mb-1"
          [ngClass]="{ 'child-description': item.isChild }"
        >
          <small class="text-secondary">{{ item.description }}</small>
        </div>

        <!-- RADIO_OPTION / Seleção simples -->
        <ng-container *ngIf="item.inputType === 'RADIO_OPTION'">
          <div
            class="flex flex-column gap-4 mt-0 field-space"
            [ngClass]="{ 'child-field': item.isChild }"
          >
            <app-form-input-radio
              [readonly]="readonly"
              [item]="item"
              [i]="i"
              [control]="form.get(item.id)"
            >
            </app-form-input-radio>
          </div>
        </ng-container>

        <!-- NUMERIC_SCALE / Escala numérica -->
        <ng-container *ngIf="item.inputType === 'NUMERIC_SCALE'">
          <div
            class="flex flex-column gap-4 mt-0 field-space"
            [ngClass]="{ 'child-field': item.isChild }"
          >
            <app-form-input-radio
              [readonly]="readonly"
              [item]="item"
              [i]="i"
              [control]="form.get(item.id)"
            >
            </app-form-input-radio>
          </div>
        </ng-container>

        <!-- SELECT / Caixa de seleção -->
        <ng-container *ngIf="item.inputType === 'SELECT'">
          <div class="form-group field-space" [ngClass]="{ 'child-field': item.isChild }">
            <app-form-input-select
              [item]="item"
              [i]="i"
              [control]="form.get(item.id)"
              [readonly]="readonly"
            >
            </app-form-input-select>
          </div>
        </ng-container>

        <!-- SELECT / Caixa de seleção -->
        <ng-container *ngIf="item.inputType === 'MULTISELECT'">
          <div class="form-group field-space" [ngClass]="{ 'child-field': item.isChild }">
            <app-form-input-select
              [item]="item"
              [i]="i"
              [control]="form.get(item.id)"
              [readonly]="readonly"
            >
            </app-form-input-select>
          </div>
        </ng-container>

        <!-- RADIO_OPTION_MULTISELECT / Seleção múltipla -->
        <ng-container *ngIf="item.inputType === 'RADIO_OPTION_MULTISELECT'">
          <div class="flex flex-column gap-4" [ngClass]="{ 'child-field': item.isChild }">
            <app-form-input-multiselect
              [item]="item"
              [i]="i"
              [control]="form.get(item.id)"
              [readonly]="readonly"
            >
            </app-form-input-multiselect>
          </div>
        </ng-container>

        <ng-container *ngIf="isNps(item)">
          <div class="nps-field" [ngClass]="{ 'child-field': item.isChild }">
            <div class="nps-field__scale">
              <button
                type="button"
                *ngFor="let value of npsValues"
                class="nps-field__option"
                [ngClass]="[
                  getNpsToneClass(value),
                  isNpsSelected(item.id, value) ? 'is-selected' : '',
                  hasNpsSelection(item.id) && !isNpsSelected(item.id, value) ? 'is-dimmed' : ''
                ]"
                [disabled]="readonly"
                (click)="selectNpsValue(item.id, value)"
              >
                <span class="nps-field__selected-emoji" *ngIf="isNpsSelected(item.id, value)">
                  {{ getSelectedNpsBand(item.id)?.emoji }}
                </span>
                <span class="nps-field__number">{{ value }}</span>
              </button>
            </div>
          </div>
        </ng-container>

        <!-- RADIO_OPTION_GRID / Grade de seleção simples -->
        <ng-container *ngIf="item.inputType === 'RADIO_OPTION_GRID'">
          <div class="grid-field-wrapper" [ngClass]="{ 'child-field': item.isChild }">
            <table class="grid-answer-table">
              <thead>
                <tr>
                  <th></th>
                  <th *ngFor="let column of getGridColumns(item)">{{ column }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of getGridRows(item)">
                  <td class="grid-answer-row-label">{{ row }}</td>
                  <td *ngFor="let column of getGridColumns(item)" class="text-center">
                    <input
                      type="radio"
                      [name]="item.id + '-' + row"
                      [checked]="isGridRadioChecked(item, row, column)"
                      [disabled]="readonly"
                      (change)="onGridRadioChange(item.id, row, column)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <!-- RADIO_OPTION_MULTISELECT_GRID / Grade de seleção múltipla -->
        <ng-container *ngIf="item.inputType === 'RADIO_OPTION_MULTISELECT_GRID'">
          <div class="grid-field-wrapper" [ngClass]="{ 'child-field': item.isChild }">
            <table class="grid-answer-table">
              <thead>
                <tr>
                  <th></th>
                  <th *ngFor="let column of getGridColumns(item)">{{ column }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of getGridRows(item)">
                  <td class="grid-answer-row-label">{{ row }}</td>
                  <td *ngFor="let column of getGridColumns(item)" class="text-center">
                    <input
                      type="checkbox"
                      [checked]="isGridCheckboxChecked(item, row, column)"
                      [disabled]="readonly"
                      (change)="onGridCheckboxChange(item.id, row, column, $any($event.target).checked)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>

        <!-- TEXTAREA / Resposta longa -->
        <ng-container *ngIf="item.inputType === 'TEXTAREA'">
          <div class="field-textarea mb-2" [ngClass]="{ 'child-field': item.isChild }">
            <app-form-input-textarea
              [readonly]="readonly"
              [item]="item"
              [i]="i"
              [isExpanded]="isExpanded(item.id)"
              [control]="form.get(item.id)"
            >
            </app-form-input-textarea>
          </div>
        </ng-container>

        <!-- TEXT / Resposta curta -->
        <ng-container *ngIf="item.inputType === 'TEXT'">
          <app-form-input-text
            [item]="item"
            [i]="i"
            [control]="form.get(item.id)"
            [readonly]="readonly"
            [ngClass]="{ 'child-field': item.isChild }"
          >
          </app-form-input-text>
        </ng-container>

        <!-- DATE / Data -->
        <ng-container *ngIf="item.inputType === 'DATE'">
          <app-form-input-date
            [item]="item"
            [i]="i"
            [control]="form.get(item.id)"
            [readonly]="readonly"
            [ngClass]="{ 'child-field': item.isChild }"
          >
          </app-form-input-date>
        </ng-container>

        <!-- TRUE / FALSE / Seleção verdadeira ou falsa-->
        <ng-container *ngIf="item.inputType === 'TRUE_OR_FALSE'">
          <div
            class="flex flex-column gap-4 mt-0 field-space"
            [ngClass]="{ 'child-field': item.isChild }"
          >
            <app-form-input-radio
              [readonly]="readonly"
              [item]="item"
              [i]="i"
              [control]="form.get(item.id)"
            >
            </app-form-input-radio>
          </div>
        </ng-container>

        <!-- FILE / Arquivo -->
        <ng-container *ngIf="item.inputType === 'FILE'">
          <div class="form-group field-space" [ngClass]="{ 'child-field': item.isChild }">
            <app-form-input-file
              [item]="item"
              [i]="i"
              [control]="form.get(item.id)"
              [readonly]="readonly"
              [recruitmentId]="recruitmentId"
              [useAdmissionPreSignedUrl]="useAdmissionFileUpload"
            >
            </app-form-input-file>
          </div>
        </ng-container>

        <div
          *ngIf="form.get(item.id).invalid && form.get(item.id).touched"
          class="error field-error-message"
          [ngClass]="{ 'child-error': item.isChild }"
        >
          Campo obrigatório
        </div>
      </div>
    </div>
    <div class="card-footer flex gap-2" *ngIf="showFooter">
      <button
        type="button"
        class="btn btn-flat-secondary"
        (click)="goToPreviousStep()"
        [disabled]="isSubmitting"
      >
        {{ currentStep == 0 ? 'Cancelar' : 'Voltar' }}
      </button>
      <ng-container *ngIf="showFinishButton; else buttonLoading">
        <button type="submit" class="btn btn-gradient-primary btn-primary-action flex gap-2">
          {{ submitButtonText }}
        </button>
      </ng-container>
      <ng-template #buttonLoading>
        <button
          *ngIf="isSubmitting"
          type="submit"
          class="btn btn-gradient-primary btn-primary-action flex gap-2"
          disabled
        >
          <span class="spinner-border spinner-border-sm"></span>
          {{ submitButtonText }}
        </button>
      </ng-template>
    </div>
  </div>
</form>
